import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumnBreak20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTextColumnBreak20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.76 4a.75.75 0 0 0-.02-1.5c-.591.008-.982.009-1.479.005A1.25 1.25 0 0 0 9 3.755V16H7.75a.75.75 0 0 0 0 1.5h1.5c.69 0 1.25-.56 1.25-1.25V4.006c.398.002.76.001 1.26-.006M1.75 5a.75.75 0 0 0 0 1.5H6A.75.75 0 1 0 6 5zm.003 6a.75.75 0 0 0-.006 1.5l4.25.016a.75.75 0 1 0 .006-1.5zM1 8.75A.75.75 0 0 1 1.75 8h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 1 8.75M1.75 14a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zM14 5a.75.75 0 0 0 0 1.5h4.25a.75.75 0 0 0 0-1.5zm.002 6a.75.75 0 0 0-.005 1.5l4.25.014a.75.75 0 1 0 .006-1.5zm-.752-2.25A.75.75 0 0 1 14 8h2.5a.75.75 0 0 1 0 1.5H14a.75.75 0 0 1-.75-.75M14 14a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumnBreak20);
